import React, { Component } from 'react'
import style from './style.module.less'

function Block({ title, content }) {
  return (
    <div className={style.blobk}>
      <div className={style.title}>{title}</div>
      <div className={style.content}>{content}</div>
    </div>
  )
}

export default class extends Component {
  render() {
    const { serviceDetail, coreFn, appImg } = this.props.product

    return (
      <div>
        <Block title="服务详情" content={serviceDetail} />

        {coreFn && <Block title="核心功能" content={coreFn} />}

        <Block
          title="应用截图"
          content={
            Array.isArray(appImg) ? (
              appImg.map((item, index) => {
                return <img key={index} src={item} className={style.img} />
              })
            ) : (
              <img src={appImg} className={style.img} />
            )
          }
        />
      </div>
    )
  }
}
